var chunkMapping = {
	"1093": [
		59734
	],
	"6954": [
		86954
	]
};
var idToExternalAndNameMapping = {
	"59734": [
		"default",
		"./webcomponents",
		14330
	],
	"86954": [
		"default",
		"./AppMount",
		71686
	]
};
var idToRemoteMap = {
	"59734": [
		{
			"externalType": "script",
			"name": "shipbob_design_system"
		}
	],
	"86954": [
		{
			"externalType": "script",
			"name": "shipbob_returns_ui"
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes.chunkMapping = chunkMapping;
__webpack_require__.federation.bundlerRuntimeOptions.remotes.idToExternalAndNameMapping = idToExternalAndNameMapping;
__webpack_require__.federation.bundlerRuntimeOptions.remotes.idToRemoteMap = idToRemoteMap;
__webpack_require__.remotesLoadingData.moduleIdToRemoteDataMapping = {
	"59734": {
		"shareScope": "default",
		"name": "./webcomponents",
		"externalModuleId": 14330,
		"remoteName": "shipbob_design_system"
	},
	"86954": {
		"shareScope": "default",
		"name": "./AppMount",
		"externalModuleId": 71686,
		"remoteName": "shipbob_returns_ui"
	}
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}